import { Icon } from "@silversea-ssc/ui-components-react"
import clsx from "clsx"
import React, { ReactElement } from "react"
import styles from "./ReceiptRow.module.scss"

type Props = {
    variant: "detail" | "title"
    label: string | ReactElement
    value?: string | number
    isPromotional?: boolean
    tabbed?: boolean
    withDot?: boolean
    note?: string | ReactElement
    className?: string
}

const ReceiptRow: React.FC<React.PropsWithChildren<Props>> = ({
    variant = "detail",
    label,
    value,
    isPromotional = false,
    tabbed = false,
    withDot = false,
    note,
    className,
}) => {
    let labelColSpan = 1
    if (!value) labelColSpan += 1
    if (!tabbed && !withDot) labelColSpan += 1

    return (
        <tr
            className={clsx(styles.row, className, {
                [styles.rowTitle]: variant === "title",
                [styles.rowDiscount]: isPromotional,
            })}
        >
            {(withDot || tabbed) && (
                <td className={styles.dotIconCol}>
                    {withDot && <Icon name="bullet" className={styles.dotIcon} padding={false} />}
                </td>
            )}
            <td colSpan={labelColSpan}>
                <div className={styles.label}>{label}</div>
                {note ? <div className={styles.labelNote}>{note}</div> : null}
            </td>
            {value ? <td className={styles.value}>{value}</td> : null}
        </tr>
    )
}

export default ReceiptRow
